export default ({ className, classes, style, items, currentPage, itemsPerPage }) => {
  return items.slice(currentPage * itemsPerPage, (currentPage + 1) * itemsPerPage);
};
